<template>
  <el-dialog
    title="查看"
    :visible.sync="visible"
    :before-close="handleClose"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-content">
      <iframe
        frameborder="0"
        allowtransparency
        width="100%"
        height="100%"
        :src="pdfUrl"
      />
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    pdfUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-dialog {
  .dialog-content {
    height: 40vh;
  }
}
</style>
